export var MIN_SXS_WIDTH = 1008;
export var MIN_READING_PANE_WIDTH = 358;
export var READING_PANE_WIDTH = 410;
export var MIN_PREVIEW_PANE_WIDTH = 600;
export var PREVIEW_PANE_WIDTH = 650;
export var READING_PANE_DEFAULT_PERCENT_SIZE = 100 * (1 / 2.89);
//# sourceMappingURL=previewPaneViewConstants.js.map